import { apiFetch } from '@/lib/apiFetch';
export const fetchSubjects = async () => {
  const response = await apiFetch('/api/v1/catalog/subjects', {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  });
  if (response.status === 401) {
    throw new Error("Authentication failed. Please log in again.");
  }
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error(`Failed to fetch profile: ${response.status}`);
  }
  return response.json();
};
